import React, { useEffect } from "react";
import { fromJS } from "immutable";
import { useDispatch } from "react-redux";
import usePersonalDocuments from "@/hooks/personalDocuments/usePersonalDocuments";
import TreeView from "../../components/personal-documents/tree-view";
import { resetCompany } from "../../actions/company.actions";
import GuidesAndTemplatesList from "@/components/guidesAndTemplatesList";
import LoadingPanel from "@/components/loadingPanel";

const PersonalDocuments = () => {
  const dispatch = useDispatch();
  const { data: personalDocumentsData, isLoading } = usePersonalDocuments();

  // Convert the data to the same format expected by TreeView
  const documents = personalDocumentsData
    ? fromJS(personalDocumentsData)
    : fromJS({});

  // Extract folder IDs from the documents data (matching the Redux reducer logic)
  const extractFolderIds = (root) => {
    if (!root || !root.get) return [];

    const result = [];
    const name = root.get("name");
    const absolutePath = root.get("absolutePath");

    if (name && absolutePath !== undefined) {
      result.push(`${name}-${absolutePath}`);
    }

    const collectFolderIds = (children, result) => {
      if (!children || !children.size) return;

      children.forEach((child) => {
        const isFolder = child.get("isFolder");
        const childName = child.get("name");
        const childAbsolutePath = child.get("absolutePath");

        if (isFolder && childName && childAbsolutePath !== undefined) {
          result.push(`${childName}-${childAbsolutePath}`);
        }

        const grandChildren = child.get("children");
        if (grandChildren && grandChildren.size) {
          collectFolderIds(grandChildren, result);
        }
      });
    };

    const children = root.get("children");
    if (children && children.size) {
      collectFolderIds(children, result);
    }

    return result;
  };

  const folderIds = fromJS(extractFolderIds(documents));

  useEffect(() => {
    dispatch(resetCompany());
  }, [dispatch]);

  if (isLoading) {
    return <LoadingPanel />;
  }

  return (
    <div className="grid h-full w-full grid-cols-3 gap-4 p-md">
      <div className="col-span-2">
        <TreeView documents={documents} folderIds={folderIds} />
      </div>
      <div className="col-span-1">
        <GuidesAndTemplatesList />
      </div>
    </div>
  );
};

export default PersonalDocuments;
